import React from 'react';

const ChatDetails = ({ details }) => {
  return (
    <div className="pb-16 ">
      <span className="fw-b mt-8 d-ib">
        {t('questions.question.chat.display_header')}
      </span>
      <div className="ws-pl">{details.message}</div>
    </div>
  );
};

export default ChatDetails;
